import { UseQueryResult } from 'react-query';
import { IErrorResponse } from '~/Models/DTO/Error.models';
import { ILocationWithStatus } from '~/Models/interfaces/Location.model';
import { useRequestLocationList } from '~/requests';
import { selectLocationList } from '~/store/provider';
import { useSelector } from 'react-redux';

export const useLocationListWithStatus = (defaultQuery: { [name: string]: any }) => {
  const locationListQuery: UseQueryResult<
    ILocationWithStatus[],
    IErrorResponse
  > = useRequestLocationList(defaultQuery);

  return locationListQuery;
};

export const useBackendLocationSearch = (searchStr: string) => {
  const locationList = useSelector(selectLocationList);
  const filteredList =
    searchStr.length > 2
      ? locationList.filter((location) =>
          location.name.toLowerCase().includes(searchStr.toLowerCase()),
        )
      : locationList;
  return { data: filteredList } as UseQueryResult<ILocationWithStatus[], IErrorResponse>;
};
